import React from 'react';
import { Alert, Box, CardActions, Stack } from '@mui/material';

/**
 * Sticky action bar for an editor: shows an unsaved-changes warning on the left and the
 * action buttons on the right, and stays at the bottom while the content scrolls.
 *
 * @param {object} props
 * @param {boolean} props.isUnsaved Shows the "You have unsaved changes." warning.
 * @param {React.ReactNode} props.children The action buttons, e.g. Cancel and Save.
 * @param {object} [props.sx] Style overrides for the bar.
 */
export const UnsavedChangesActions = ({ isUnsaved, children, sx }) => {
	return (
		<CardActions
			sx={(theme) => ({
				position: 'sticky',
				bottom: 0,
				zIndex: 11,
				mt: 1,
				backgroundColor: theme.palette.background.paper,
				borderTop: `1px solid ${theme.palette.divider}`,
				...sx,
			})}
		>
			<Stack direction='row' spacing={1} alignItems='center' sx={{ width: '100%' }}>
				<Box sx={{ flex: 1 }}>
					{isUnsaved && (
						<Alert severity='warning' sx={{ py: 0.5 }}>
							You have unsaved changes.
						</Alert>
					)}
				</Box>
				{children}
			</Stack>
		</CardActions>
	);
};

export default UnsavedChangesActions;
UnsavedChangesActions.displayName = 'UnsavedChangesActions';
